var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoGuidesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25016 5.80448C6.25016 5.40675 6.25016 5.20788 6.33328 5.09685C6.40571 5.0001 6.51659 4.93957 6.63714 4.93096C6.77548 4.92108 6.94277 5.02862 7.27733 5.2437L11.2112 7.77259C11.5015 7.95922 11.6466 8.05254 11.6968 8.1712C11.7406 8.27488 11.7406 8.39187 11.6968 8.49555C11.6466 8.61421 11.5015 8.70752 11.2112 8.89416L7.27734 11.423C6.94277 11.6381 6.77548 11.7457 6.63714 11.7358C6.51659 11.7272 6.40571 11.6666 6.33328 11.5699C6.25016 11.4589 6.25016 11.26 6.25016 10.8623V5.80448Z",
    stroke: "#0A756F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 4.83337C0.833496 3.43324 0.833496 2.73318 1.10598 2.1984C1.34566 1.72799 1.72811 1.34554 2.19852 1.10586C2.7333 0.833374 3.43336 0.833374 4.8335 0.833374H11.8335C13.2336 0.833374 13.9337 0.833374 14.4685 1.10586C14.9389 1.34554 15.3213 1.72799 15.561 2.1984C15.8335 2.73318 15.8335 3.43324 15.8335 4.83337V11.8334C15.8335 13.2335 15.8335 13.9336 15.561 14.4683C15.3213 14.9388 14.9389 15.3212 14.4685 15.5609C13.9337 15.8334 13.2336 15.8334 11.8335 15.8334H4.8335C3.43336 15.8334 2.7333 15.8334 2.19852 15.5609C1.72811 15.3212 1.34566 14.9388 1.10598 14.4683C0.833496 13.9336 0.833496 13.2335 0.833496 11.8334V4.83337Z",
    stroke: "#0A756F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGuidesIcon);
export default __webpack_public_path__ + "static/media/video_guides_icon.ad19db54840b4a67ad1b83d5afe5d1d5.svg";
export { ForwardRef as ReactComponent };